import {
  EBoxEventSaveNameAction,
  IBoxCore,
  IGameCore,
  ISessionCore,
  TBoxBodyPublic,
  TGamePublic,
  TSessionBodyPublic,
} from '@lbs/shared-rp-types'
import { makeAutoObservable } from 'mobx'
import eventBus, { getBoxEventName } from './utils/eventBus'

export default class RussianPokerStore {
  gameId: string = ''

  game: TGamePublic | null = null

  session: TSessionBodyPublic | null = null

  boxes: Array<TBoxBodyPublic> = []

  isOnlinePlayer = false

  lastEventBox: { target: IBoxCore; action: EBoxEventSaveNameAction; timestamp: number } | null = null

  showPopupExit = false

  constructor() {
    makeAutoObservable(this)
  }

  get isOnlineStatusPlayer(): boolean {
    return this.isOnlinePlayer
  }

  togglePopupExit = () => {
    this.showPopupExit = !this.showPopupExit
  }

  setOnlineStatusPlayer = (status: boolean) => {
    this.isOnlinePlayer = status
  }

  onPlayerStatusChange = (data: { playerId: string; gameId: string; status: 'joined' | 'left'; timestamp: string }) => {
    this.isOnlinePlayer = data.status === 'joined'
  }

  setGameId = (gameId: string) => {
    this.gameId = gameId
  }

  setGame = (game: TGamePublic) => {
    this.game = game
  }

  setSession = (session: TSessionBodyPublic) => {
    this.session = session
  }

  setBoxes = (boxes: Array<TBoxBodyPublic>) => {
    this.boxes = [...boxes]
  }

  pathGame = (game: { target: IGameCore; data: Partial<TGamePublic> }) => {
    if (game.target.gameId !== this.gameId) return

    if (this.game) {
      Object.assign(this.game, game.data)
    } else {
      this.game = { ...game.data } as TGamePublic
    }
  }

  pathSession = (session: { target: ISessionCore; data: Partial<TSessionBodyPublic> }) => {
    if (session.target.gameId !== this.gameId) return
    if (session.target.sessionId !== this.game?.sessionId) return

    if (this.session) {
      Object.assign(this.session, session.data)
    } else {
      this.session = { ...session.data } as TSessionBodyPublic
    }
  }

  pathBoxes = (payloadBox: {
    target: {
      gameId: string
      sessionId: string
      seatNumber: number
    }
    data: Partial<TBoxBodyPublic>
  }) => {
    if (payloadBox.target.gameId !== this.gameId) return
    if (payloadBox.target.sessionId !== this.game?.sessionId) return

    const targetBox = this.boxes.find((box) => {
      return box.seatNumber === payloadBox.target.seatNumber
    })

    if (!targetBox) {
      this.boxes.push({ ...payloadBox.data } as TBoxBodyPublic)
      return
    }

    Object.assign(targetBox, payloadBox.data)
  }

  eventBox = (payloadEventBox: { target: IBoxCore; action: EBoxEventSaveNameAction }) => {
    const { target, action } = payloadEventBox

    const eventKey = getBoxEventName({
      ...target,
    })

    eventBus.emit(eventKey, action)

    this.lastEventBox = {
      ...payloadEventBox,
      timestamp: Date.now(),
    }
  }
}
